import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import { MemoryRouter } from 'react-router-dom';
import SubNav from './sub_nav';

describe('SubNav', () => {
    const renderWithRouter = (path = '/slides') => {
        return render(
            <MemoryRouter initialEntries={[path]}>
                <SubNav />
            </MemoryRouter>
        );
    };

    it('renders all navigation tabs', () => {
        const { getByText } = renderWithRouter();
        expect(getByText('Slide Editor')).toBeTruthy();
        expect(getByText('Document Converter')).toBeTruthy();
        expect(getByText('Themes')).toBeTruthy();
    });

    it('renders Songs tab', () => {
        const { getByText } = renderWithRouter();
        expect(getByText('Songs')).toBeTruthy();
    });
});
